import { LoggingState } from "./logging.store";
import { Lens } from "src/app/shared/utilities/state/Optics";

/**
 * Logging Lenses
 */
const loggingProps = Lens.fromProp<LoggingState>();
export const logLens = loggingProps("log");
export const lastLogSentLens = loggingProps("lastLogSent");
